export const ALERT_TYPES = {
    SUCCESS: 'success',
};
export const SUCCESS_MESSAGES = {
    PASSWORD_CHANGED: 'Password changed successfully',
};

export const ORGANIZATION_CHECKLIST_FEATURE_KEY = 'organizationChecklist';
export const DEFAULT_CHECKLIST_FEATURE_KEY = 'defaultChecklist';
